module.exports = __webpack_public_path__ + "static/img/dzwiek.272533c9.png";